import { render } from "./PolicyGroupSelector.vue?vue&type=template&id=6905d703&scoped=true"
import script from "./PolicyGroupSelector.vue?vue&type=script&lang=js"
export * from "./PolicyGroupSelector.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./PolicyGroupSelector.vue?vue&type=style&index=1&id=6905d703&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6905d703"]])

export default __exports__